const e = {
  name: "BatteryEmpty",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 7C1 5.89543 1.89543 5 3 5H17C18.1046 5 19 5.89543 19 7V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V7ZM17 7V17H3V7H17Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23 10C23 9.44772 22.5523 9 22 9C21.4477 9 21 9.44772 21 10V14C21 14.5523 21.4477 15 22 15C22.5523 15 23 14.5523 23 14V10Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as BatteryEmpty
};
